import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@dotcom/crown-ui';
import { removeBeforeUnloadEvent } from '../../../utils';
import { ActionButtonProps } from '../system-failure-dialog-types';

export const ActionButton = ({ click }: ActionButtonProps): React.ReactElement => {
  const { t } = useTranslation();

  const onClick = () => {
    removeBeforeUnloadEvent();
    click();
  };

  return (
    <Button onClick={onClick} variant="primary" testId="action-button">
      {t('systemFailureDialog.action')}
    </Button>
  );
};
